import type { NuxtApp } from '#app'

export const isHydratingServerRender = (nuxtApp: NuxtApp): boolean =>
  nuxtApp.isHydrating === true && nuxtApp.payload.serverRendered === true
